import { ALL_VISIT_COUNTS } from '@/pages/AllVisitsPage/AllVisits.gql';
import { gql } from '@apollo/client';
import { useMutation } from '@apollo/client/react';

import { errorToast } from '../../../toast';

// Individual Visit Request Promotion Mutation
export const usePromoteVisitRequest = ({ visitRequestId }: { visitRequestId: string }) => {
    const [promoteVisitRequest, results] = useMutation(PROMOTE_VISIT_REQUEST_MUTATION, {
        variables: {
            visitRequestId,
        },
        onError: (error) => {
            if (error instanceof Error) {
                errorToast(error.message);
            }
        },
        refetchQueries: [ALL_VISIT_COUNTS],
    });

    return { promoteVisitRequest, ...results };
};

const VisitRequestPromotionFragment = gql`
    fragment VisitRequestPromotionFragment on VisitRequest {
        id
        state
        workflowStep
        visit {
            id
        }
    }
`;

const PROMOTE_VISIT_REQUEST_MUTATION = gql`
    mutation PromoteVisitRequest($visitRequestId: UUID!) {
        promoteVisitRequest(input: { visitRequestId: $visitRequestId }) {
            ...VisitRequestPromotionFragment
        }
    }
    ${VisitRequestPromotionFragment}
`;
